import CRUDFactory from '@/services/CRUDFactory';

export const categoriesCRUD = CRUDFactory('/faq-categories');
export const questionsCRUD = CRUDFactory('/faq');

export default {
  categories: categoriesCRUD,
  questions: questionsCRUD,
};
